class @EDM

  # Callbacks to EDM functions will call with two parameters: (data, error)

  constructor: () ->
    @user = null
    @token = null
    @servers = [
      "api-a.edmdesigner.com"
      "api-b.edmdesigner.com"
      "api-c.edmdesigner.com"
    ]

  getProject: (projectId, fn) =>
    @http "GET", "/json/project/getProject/#{ projectId }", null, "json", 0, (project, err) =>
      fn?(project, err, @isNotFoundError(err))

  getProjectHtml: (projectId, fn) =>
    @http "GET", "/json/project/generate/#{ projectId }", null, "html", 0, (html, err) =>
      if _.isString(html) && !err
        fn?(html, null, false)
      else
        fn?(null, err, @isNotFoundError(err))

  createProject: (title, document, fn) =>
    data =
      title: title
      document: document
      customData: {}

    @http("POST", "/json/project/create", data, "json", 0, fn)

  openProjectURL: (projectId) =>
    "https://api-static.edmdesigner.com/?" + $.param({
      projectId: projectId
      user: @user
      token: @token
      language: "en"
      autosave: 0
    })

  duplicateProject: (sourceProjectId, newTitle, fn) =>
    @http "GET", "/json/project/duplicate/#{ sourceProjectId }", null, "json", 0, (project, err) =>
      if project && !err
        @http "GET", "/jsonp/project/updateInfo/#{ project._id }", { data: { title: newTitle } }, "json", 0, (_, err) =>
          if !err
            project.title = newTitle
            fn(project, null, false)
          else
            fn(null, err, @isNotFoundError(err))
      else
        fn(null, err, @isNotFoundError(err))

  getGeneratedProject: (projectId, fn) =>
    @getProject projectId, (project, err) =>
      if project && !err
        @getProjectHtml projectId, (html, err) =>
          if _.isString(html) && !err
            project.html = html
            fn(project, null, false)
          else
            fn(null, err, @isNotFoundError(err))
      else
        fn(null, err, @isNotFoundError(err))

  http: (method, path, data, dataType, serverIndex, fn) =>
    if @user && @token
      if serverIndex >= @servers.length
        fn(null, "Failed to communicate. Try again.")
      else
        auth_params = "?" + $.param({ user: @user, token: @token })

        $.ajax({
          method: method
          url: "//#{ @servers[serverIndex] }#{ path }#{ auth_params }"
          data: data
          dataType: dataType
          success: (response) =>
            if dataType == "html" && /^{"err":/.test(response)
              # Handle this as a special case because there are endpoints that
              # return a JSON error even though it's supposed to send us HTML.
              fn(null, response)
            else if response.err
              fn(null, "Received error from server: #{ response.err }")
            else
              fn(response, null)
          error: (response) =>
            @http(method, path, data, dataType, serverIndex + 1, fn)
        })
    else
      $.ajax({
        method: "POST"
        url: Routes.edm_designer_callback_path()
        dataType: "json"
        success: (response) =>
          if response.success
            @user  = response.user
            @token = response.token

            @http(method, path, data, "json", 0, fn)
          else
            fn(null, response.error_message || "Unknown error obtaining token from server.")
        error: =>
          fn(null, "Failed to obtain token from server.")
      })

  isNotFoundError: (err) =>
    _.isString(err) && /Project not found!|The given project does not exist!/.test(err)

  @runSystemConfigTest: =>
    $results     = $("#system_config_edm_integration_test_results")
    apiKey       = $("#system_config_edm_integration_api_key").val()
    magicWord    = $("#system_config_edm_integration_api_magic_word").val()
    writeBusy    =         -> $results.html($("<span></span>").addClass(""       ).text(t("responsive_content_editor.api_test.running")))
    writeSuccess =         -> $results.html($("<span></span>").addClass("success").text(t("responsive_content_editor.api_test.success")))
    writeError   = (error) -> $results.html($("<span></span>").addClass("error"  ).text(error))

    writeBusy()

    if !apiKey || !magicWord
      writeError(t("responsive_content_editor.api_test.missing_key"))
      return

    $.ajax
      method: "GET"
      url: Routes.test_new_api_key_edm_designer_callback_path(api_key: apiKey, magic_word: magicWord)
      dataType: "json"
      success: (data) =>
        if data.success
          writeSuccess()
        else
          writeError(data.error_message)
      error: =>
        writeError(t("responsive_content_editor.api_test.connection_failed"))
